const War = require('../../entities/War');
const { Age } = require('../../Constants/Constants');
const WarNames = require("../Names/WarNames");

class WarOverCulture extends War {
    constructor()
    {
        super(
            Age.Age3,
            WarNames.WarOverCulture,
            "The victor takes 5 culture plus 1 culture for each point of military advantage from the defeated civilization.",
            3,
            {}
        )
    }
}

module.exports = WarOverCulture;